import SparkMD5 from 'spark-md5';

const CHUNK_SIZE = 2097152; // 2MB

export default class BlobDigester {
    public static async digestMD5(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            const totalSize = blob.size;
            const chunks = Math.ceil(totalSize / CHUNK_SIZE);

            let currentChunk = 0;
            const spark = new SparkMD5.ArrayBuffer();

            const reader = new FileReader();

            const next = () => {
                const start = currentChunk * CHUNK_SIZE;
                const end = Math.min(start + CHUNK_SIZE, totalSize);

                reader.readAsArrayBuffer(blob.slice(start, end));
                currentChunk += 1;
            };

            next();

            reader.onload = (e) => {
                const data = e.target?.result;
                if (!data || !(data instanceof ArrayBuffer)) {
                    reject('unable to read blob');
                    return;
                }
                spark.append(data);

                if (currentChunk < chunks) {
                    next();
                } else {
                    resolve(spark.end());
                }
            };

            reader.onerror = () => {
                reject('unable to read blob');
            };
        });
    }
}
